export const GET_USER_PETS_REQUEST = 'GET_USER_PETS_REQUEST';
export const GET_USER_PETS_SUCCESS = 'GET_USER_PETS_SUCCESS';
export const GET_USER_PETS_FAILED = 'GET_USER_PETS_FAILED';

export const CREATE_PRO_PET_PROVIDER_REQUEST = 'CREATE_PRO_PET_PROVIDER_REQUEST';
export const CREATE_PRO_PET_PROVIDER_SUCCESS = 'CREATE_PRO_PET_PROVIDER_SUCCESS';
export const CREATE_PRO_PET_PROVIDER_FAILED = 'CREATE_PRO_PET_PROVIDER_FAILED';

export const DELETE_PRO_PET_PROVIDER_REQUEST = 'DELETE_PRO_PET_PROVIDER_REQUEST';
export const DELETE_PRO_PET_PROVIDER_SUCCESS = 'DELETE_PRO_PET_PROVIDER_SUCCESS';
export const DELETE_PRO_PET_PROVIDER_FAILED = 'DELETE_PRO_PET_PROVIDER_FAILED';

export const CREATE_PRO_PET_REQUEST = 'CREATE_PRO_PET_REQUEST';
export const CREATE_PRO_PET_SUCCESS = 'CREATE_PRO_PET_SUCCESS';
export const CREATE_PRO_PET_FAILED = 'CREATE_PRO_PET_FAILED';

export const UPDATE_PRO_PET_REQUEST = 'UPDATE_PRO_PET_REQUEST';
export const UPDATE_PRO_PET_SUCCESS = 'UPDATE_PRO_PET_SUCCESS';
export const UPDATE_PRO_PET_FAILED = 'UPDATE_PRO_PET_FAILED';

export const GET_BREEDS_REQUEST = 'GET_BREEDS_REQUEST';
export const GET_BREEDS_SUCCESS = 'GET_BREEDS_SUCCESS';
export const GET_BREEDS_FAILED = 'GET_BREEDS_FAILED';

export const GET_SPECIES_REQUEST = 'GET_SPECIES_REQUEST';
export const GET_SPECIES_SUCCESS = 'GET_SPECIES_SUCCESS';
export const GET_SPECIES_FAILED = 'GET_SPECIES_FAILED';

export const GET_PET_REQUEST = 'GET_PET_REQUEST';
export const GET_PET_SUCCESS = 'GET_PET_SUCCESS';
export const GET_PET_FAILED = 'GET_PET_FAILED';

export const GET_PET_HEALTH_REQUEST = 'GET_PET_HEALTH_REQUEST';
export const GET_PET_HEALTH_SUCCESS = 'GET_PET_HEALTH_SUCCESS';
export const GET_PET_HEALTH_FAILED = 'GET_PET_HEALTH_FAILED';

export const GET_GENDERS_SUCCESS = 'GET_GENDERS_SUCCESS';
export const GET_GENDERS_REQUEST = 'GET_GENDERS_REQUEST';

export const GET_STATUSES_SUCCESS = 'GET_STATUSES_SUCCESS';
export const GET_STATUSES_REQUEST = 'GET_STATUSES_REQUEST';

export const GET_NEUTERED_REQUEST = 'GET_NEUTERED_REQUEST';
export const GET_NEUTERED_SUCCESS = 'GET_NEUTERED_SUCCESS';

export const GET_SPAYED_REQUEST = 'GET_SPAYED_REQUEST';
export const GET_SPAYED_SUCCESS = 'GET_SPAYED_SUCCESS';

export const GET_DECLAWED_REQUEST = 'GET_DECLAWED_REQUEST';
export const GET_DECLAWED_SUCCESS = 'GET_DECLAWED_SUCCESS';

export const GET_MEDICAL_CONDITIONS_REQUEST = 'GET_MEDICAL_CONDITIONS_REQUEST';
export const GET_MEDICAL_CONDITIONS_SUCCESS = 'GET_MEDICAL_CONDITIONS_SUCCESS';
export const GET_MEDICAL_CONDITIONS_FAILED = 'GET_MEDICAL_CONDITIONS_FAILED';

export const GET_OWNER_IDENTIFICATIONS_REQUEST = 'GET_OWNER_IDENTIFICATIONS_REQUEST';
export const GET_OWNER_IDENTIFICATIONS_SUCCESS = 'GET_OWNER_IDENTIFICATIONS_SUCCESS';

export const SET_ACTIVE_PET = 'SET_ACTIVE_PET';
export const SET_USER_PETS = 'SET_USER_PETS';
